export enum ModuleUserBookingRequestType {
    Inactive = 'inactive',
    Active = 'active',
    ActiveLinkedToProgram = 'active_linked_to_program',
}
